import React from 'react';
import PropTypes from 'prop-types';
import {
  FDChart, FDChartProvider, FDTitleText, FDStack,
} from '@facet-wealth/design';
import { useDataSet } from 'Components/ComponentLibrary/Organisms/DataSet/useDataSet';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box/Box';

export const DataSet = ({
  dataSetResource,
  height,
  onClick,
  ChartLegend,
  ChartTooltip,
  showAxisLine,
}) => {
  if (typeof height !== 'number' || height <= 0) {
    throw new Error('Developer configuration error: height must be a positive number.');
  }

  const dataset = useDataSet(dataSetResource);

  return (
    <FDChartProvider dataset={dataset}>
      <Box height={height} width={'100%'}>
        {dataSetResource.attr('title') && (
          <FDStack direction={'column'} alignItems={'center'}>
            <FDTitleText value={dataSetResource.attr('title')} alignSelf={'center'} />
          </FDStack>
        )}
        <FDChart
          tooltip={ChartTooltip}
          onClick={onClick}
          showAxisLine={showAxisLine}
        />
      </Box>
      {ChartLegend ? <ChartLegend /> : null}
    </FDChartProvider>
  );
};

DataSet.defaultProps = {
  onClick: undefined,
  ChartTooltip: undefined,
  ChartLegend: undefined,
  showAxisLine: false,
};

DataSet.propTypes = {
  dataSetResource: PropTypes.object.isRequired,
  height: PropTypes.number.isRequired,
  onClick: PropTypes.func,
  ChartTooltip: PropTypes.func,
  ChartLegend: PropTypes.func,
  showAxisLine: PropTypes.bool,
};
